import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import type { TrackProperties } from './Track.types';

const TRACK_WIDTH = 52;
const TRACK_HEIGHT = 32;

export const Track = styled(Box, {
  shouldForwardProp: property =>
    !['isChecked', 'isDisabled', 'dataTest'].includes(property as string),
})<TrackProperties>(({ theme, isChecked, isDisabled }) => {
  const isDark = theme.palette.mode === 'dark';

  return {
    width: TRACK_WIDTH,
    height: TRACK_HEIGHT,
    borderRadius: TRACK_HEIGHT / 2,
    position: 'relative',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    overflow: 'hidden', // Clip StateLayer to track bounds
    transition: theme.transitions.create(
      ['background-color', 'border-color', 'opacity'],
      {
        duration: 250,
        easing: theme.transitions.easing.easeInOut,
      },
    ),
    opacity: isDisabled ? 0.38 : 1,
    '&:focus-within': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    ...(isChecked
      ? {
          backgroundColor: isDisabled
            ? isDark
              ? theme.palette.grey[700]
              : theme.palette.grey[400]
            : isDark
              ? theme.palette.primary.light
              : theme.palette.primary.main,
          border: 'none',
        }
      : {
          backgroundColor: isDark
            ? theme.palette.grey[800]
            : theme.palette.grey[200],
          border: `2px solid ${isDark ? theme.palette.grey[600] : theme.palette.grey[500]}`,
        }),
  };
});
